<script setup>
import { setup } from './PwResetDoneModal'

const props = defineProps({
  resetDone: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const {
  // props
  modalVisible,
  // functions
  closeModal,
} = setup(props)
</script>

<template>
  <!--modal03-->
  <div
    v-show="modalVisible"
    class="md_modal modal03"
  >
    <button
      class="bgLayer js_modalX"
      v-on:click="closeModal"
    ></button>
    <div class="modalSet">
      <div class="Content">
        <div class="textArea">
          <div class="catch">パスワード再設定完了</div>
          <p class="copy">パスワードの再設定が完了しました。再設定したパスワードでログインしてください。</p>
        </div>
        <div class="actionArea">
          <button
            class="md_btn md_btn--medium md_btn--second js_modalX"
            v-on:click="closeModal"
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--/modal03-->
</template>
